import React from 'react';

import Record from 'ui/Record/Record';

import MainHeader from 'components/MainHeader';

import { Button } from 'components/Button';

import routes from 'core/routes';
import { useNavBarHeight } from 'utils/hooks/navbar';

import AddEntityModal from 'components/Entities/AddEntityModal/AddEntityModal';
import { useStore } from 'utils/hooks/store';

import ContactsTable from './components/ContactsTable';

const Contacts: React.FunctionComponent = (): React.ReactElement => {
  const navBarHeight = useNavBarHeight();
  const [openModal, setOpenModal] = React.useState(false);
  const refreshRef = React.useRef<Function | null>(null);
  const { session, contactDetails, notification } = useStore();

  const [contactsCount, setContactsCount] = React.useState(0);

  React.useEffect(() => {
    const fetchLoadCount = async (): Promise<void> => {
      const count = await contactDetails.loadCount();
      setContactsCount(count);
    };

    fetchLoadCount();
  }, []);

  const onClose = (created: boolean): void => {
    setOpenModal(false);
    if (refreshRef.current && created) {
      refreshRef.current();
    }
  };
  const onRefreshCallback = (callback: Function): void => {
    refreshRef.current = callback;
  };

  const handleNewButtonClick = (): void => {
    if (session.user && contactsCount >= session.user.organisation.maximumContactsAllowed) {
      notification.enqueueErrorSnackbar('Maximum contacts limit reached. Please contact us to increase your limit.');
    } else {
      setOpenModal(true);
    }
  };

  return (
    <>
      <Record
        Header={
          <MainHeader
            title="Contacts"
            breadcrumbs={[
              { label: 'Contacts', link: routes.dashboard.contacts.toString() },
              { label: 'Overview', link: routes.dashboard.contacts.toString() },
            ]}
            action={
              <Button variant="contained" size="large" onClick={handleNewButtonClick}>
                New
              </Button>
            }
          />
        }
        Content={(onError) => <ContactsTable onError={onError} onRefreshCallback={onRefreshCallback} />}
        navBarHeight={navBarHeight}
      />
      {openModal && <AddEntityModal store={contactDetails} onClose={onClose} />}
    </>
  );
};

export default Contacts;
